import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverviewCard } from 'components/dashboard/components/overview-card';
import ReviewTable from 'components/dashboard/components/review-table';
import {
  Container,
  FlexRow,
  HeaderFlexRow,
  HeadingTitle,
} from 'components/styled-components';
import colors from 'utils/colors';
import { getDashboardHeaders, getDashboardFields } from 'utils/functions';
import * as actions from 'actions/vendor-request';
import {
  StatContainer,
  BlueSection,
  DashboardContent,
  H2Dashboard,
} from 'components/dashboard/components/styled-components';

const DashboardOverview = ({ awaitingCompletion, historical }) => (
  <StatContainer>
    <OverviewCard
      title="My ongoing assessments"
      icon="time"
      color={colors.icons.azure}
      data={awaitingCompletion}
      filterType="requestStatus"
      filter="Awaiting Third Party Completion"
    />
    <OverviewCard
      title="My historical assessments"
      icon="updated"
      color={colors.icons.amber}
      data={historical}
      filterType="statusCategory"
      filter={['pass', 'review', 'fail']}
      filterAltName={'Submitted'}
    />
  </StatContainer>
);

class DashboardThirdParty extends Component {
  componentDidMount() {
    this.props.fetchAllVendorRequests({ start: 0, limit: -1 });
  }

  render() {
    const { awaitingCompletion, historical, appUser } = this.props;
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Dashboard</HeadingTitle>
        </HeaderFlexRow>
        <BlueSection>
          <H2Dashboard>Assessments Overview</H2Dashboard>
          <DashboardOverview
            awaitingCompletion={awaitingCompletion['totalCount']}
            historical={historical['totalCount']}
          />
          <H2Dashboard>Recent Assessments</H2Dashboard>
        </BlueSection>

        <DashboardContent>
          <FlexRow flexWrap="wrap">
            <ReviewTable
              title="My Ongoing Assessments"
              data={awaitingCompletion}
              userRole={appUser.roleDisplayName}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="time"
              color={colors.icons.azure}
              flexBasis="100%"
              filterType="requestStatus"
              filter="Awaiting Third Party Completion"
              appUser={appUser}
            />
            <ReviewTable
              title="All Historical Assessments"
              data={historical}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="updated"
              color={colors.icons.amber}
              flexBasis="100%"
              filterType="statusCategory"
              filter={['pass', 'review', 'fail']}
              filterAltName={'Submitted'}
              appUser={appUser}
            />
          </FlexRow>
        </DashboardContent>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  awaitingCompletion: state.vendorRequest.allRequestsInProgress,
  historical: state.vendorRequest.allRequestsNotInProgress,
});

DashboardThirdParty = connect(
  mapStateToProps,
  actions
)(DashboardThirdParty);

export default DashboardThirdParty;
